import React from 'react'

import './Footer.css'

export default ({ globalSettings, socialSettings, navLinks }) => (
  <footer className='Footer'>
    <div className='container taCenter'>
      <span>© 2017 All rights reserved.</span>
    </div>
  </footer>
)



// WEBPACK FOOTER //
// ./src/components/Footer.js